export default function verifierDroits(infosCompte, droitsDeFeature) {
    if (infosCompte && infosCompte.roles && infosCompte.roles[0]) {
        const { roles } = infosCompte;
        return droitsDeFeature.find((droit) => {
            return roles.includes(droit);
        });
    }
    return false;
}
